import React, { PropTypes } from 'react';
import IconButton from 'material-ui/IconButton';
import IconClose from '../../Icons/IconClose';
import LoggedAppBar from '../../LoggedLayout/LoggedAppBar';
import RaisedButton from 'material-ui/RaisedButton';
import RichEditor from '../../form/RichEditor';
import Input from '../../form/Input';
import InputToggle from '../../form/InputToggle';
import ImageUpload from '../../form/ImageUpload';
import config from 'config';
import {Container, Row, Col} from 'react-grid-system';
import { catHTML } from '../../../utilites/textUtilites';

import { VideoInput } from '../../form/VideoInput'

class FanBoxMessageForm extends React.Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    model: PropTypes.object.isRequired,
    goIndex: PropTypes.func.isRequired,
    onCloseEditForm: PropTypes.func.isRequired,
    isPublished: PropTypes.bool.isRequired,
    save: PropTypes.func.isRequired
  };

  async save(data) {
    data.short_content = catHTML(data.content, 80);
    await this.props.save(this.props.model, data);
    return this.props.goIndex();
  }

  componentWillUnmount() {
    this.props.onCloseEditForm();
  }

  processSubmit = () => {
    return this.props.handleSubmit(this.save.bind(this))(this.props.values);
  };

  publish = () => {
    let {handleSubmit, save, model, goIndex} = this.props;
    return handleSubmit(async (data) =>  {
      data.short_content = catHTML(data.content, 80);
      await save(
        model,
        Object.assign({}, data, {published: true})
      );
      return goIndex();
    })();
  };

  render() {
    let {
      label,
      isPublished,
      pristine,
      fields: {
        image,
        title,
        content,
        vip,
        video
      },
      valid,
      submitting,
      goIndex
    } = this.props;

    let disabled = isPublished;

    return (
      <form onSubmit={this.processSubmit} style={{padding: 16}}>
        <LoggedAppBar
          isStatic={true}
          title={label}
          iconElementRight={
            <IconButton onClick={goIndex}><IconClose /></IconButton>
          }
        />

        <Container style={{marginLeft: 0}}>
          <Row>
            <Col lg={8} md={10} xs={12}>
              { !isPublished || video.value ? <Row>
                <Col xs={12}>
                  <VideoInput
                    label='Video'
                    allowedFormats={config.allowedFormats}
                    size="3GB"
                    disabled={ disabled }
                    screenShotImageSize={config.streamCrop}
                    onScreenShotImage={async (screenShot) => {
                      image.onChange(screenShot);
                    }}
                    {...video}/>
                </Col>
              </Row> : null }
              <Row>
                <Col xs={12}>
                  <ImageUpload
                    label="Picture"
                    imageWidth='auto'
                    imageHeight='300px'
                    crop={config.fanBoxMessageCrop}
                    disabled={disabled}
                    {...image}
                  />
                </Col>
              </Row>

              <Row>
                <Col xs={12}>
                  <Input label="Title" required disabled={disabled} {...title}/>
                </Col>

                <Col xs={12}>
                  <InputToggle label="VIP only" required disabled={disabled} {...vip}/>
                </Col>

                <Col xs={12}>
                  <RichEditor label="Content" required disabled={disabled} {...content}/>
                </Col>

                <Col xs={6}>
                  <RaisedButton secondary={true}
                                fullWidth={true}
                                disabled={!valid || submitting || isPublished || pristine}
                                onClick={this.processSubmit}
                                label="Save"/>
                </Col>
                <Col xs={6}>
                  <RaisedButton primary={true}
                                fullWidth={true}
                                disabled={!valid || submitting || isPublished || disabled}
                                onClick={this.publish}
                                label="Save and Publish"/>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>

      </form>
    );
  }
}

export default FanBoxMessageForm;



// WEBPACK FOOTER //
// ./src/components/FanBox/FanBoxMessageForm/FanBoxMessageForm.jsx